/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-tag-spacing */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable react/jsx-fragments */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/no-unused-class-component-methods */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _moment = _interopRequireDefault(require("moment"));
var _is_js = _interopRequireDefault(require("is_js"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _DatePicker = _interopRequireDefault(require("Components/Forms/Elements/V2/DatePicker"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _LeaveWithoutSavingModal = _interopRequireDefault(require("Modals/LeaveWithoutSavingModal"));
var _AccountStatusModal = _interopRequireDefault(require("Modals/AccountStatusModal"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _options = _interopRequireDefault(require("Shared/options"));
var _utilities = require("Shared/utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const {
  app
} = window;
const monitoring_type_options = _options.default.monitoring_type_options;
class CandidateForm extends _react.Component {
  state = {
    status_messages: {},
    'candidate[handicap_status]': [],
    'candidate[monitoring]': [],
    'candidate[action_list]': [],
    'candidate[monitoring_status]': [],
    'candidate[interested_companies]': [],
    'candidate[dispositif]': [],
    'candidate[cgu_accepted]': true,
    'candidate[cv_status]': 'Je n’ai pas fait mon CV et je souhaite de l’aide pour le rédiger',
    openAccountStatusModal: false,
    monitoring_modal_trigger: undefined,
    current_tab: 0,
    openLeaveWhithoutSavingModal: false,
    autocompleteDep: [],
    show_suggestions: false
  };
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  handleV2Change = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.handleChange({
      e,
      value,
      name
    });
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchCandidate();
    }
    component.fetchCompany();
    component.fetchProfessionalDomain();
    component.fetchUser();
  }
  fetchCandidate = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-all', {
      id: props.id || document.location.pathname.split('/liste-des-candidats/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const candidate = response.candidates?.[0];
      if (!candidate) {
        throw {
          error: 'Candidat introuvable.'
        };
      }
      candidate.now_situation = candidate.now_situation || {};
      const cv_download = (candidate.cv_download || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete candidate.cv_download;
      const tsa_file = (candidate.tsa_diagnostic?.file || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.candidates[0].tsa_diagnostic?.file;
      const rqth_file = (candidate.rqth?.file || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.candidates[0].rqth?.file;
      let update = {};
      let candidate_monitoring = (candidate.monitoring || []).map(function (data, i) {
        let file_parsed = (data.file || []).map(function (file) {
          let descriptor = {
            ...file,
            status: 'uploaded',
            filename: file.url.slice(file.url.lastIndexOf('/') + 1),
            pdf: true
          };
          return descriptor;
        });
        let monitoring = {
          ...data,
          file: file_parsed
        };
        update['__files-candidate[monitoring][' + monitoring.id + '][file]'] = file_parsed;
        return monitoring;
      });
      delete candidate.monitoring;
      let candidate_action_list = (candidate.action_list || []).map(function (data, i) {
        let file_parsed = (data.file || []).map(function (file) {
          let descriptor = {
            ...file,
            status: 'uploaded',
            filename: file.url.slice(file.url.lastIndexOf('/') + 1),
            pdf: true
          };
          return descriptor;
        });
        let action_list = {
          ...data,
          file: file_parsed
        };
        update['__files-candidate[action_list][' + action_list.id + '][file]'] = file_parsed;
        return action_list;
      });
      delete candidate.action_list;
      const monitoring_status = candidate.monitoring_status || [];
      delete candidate.monitoring_status;
      const interested_companies = candidate.interested_companies || [];
      delete candidate.interested_companies;
      update = {
        ...update,
        ...(0, _getStateFromObject.default)({
          data: candidate,
          model: 'candidate'
        })
      };
      component.setState({
        ...update,
        'candidate[cv_download]': cv_download,
        '__files-candidate[cv_download]': cv_download,
        'candidate[tsa_diagnostic][file]': tsa_file,
        '__files-candidate[tsa_diagnostic][file]': tsa_file,
        'candidate[rqth][file]': rqth_file,
        '__files-candidate[rqth][file]': rqth_file,
        'candidate[action_list]': candidate_action_list,
        'candidate[monitoring]': candidate_monitoring,
        'candidate[monitoring_status]': monitoring_status,
        'candidate[interested_companies]': interested_companies,
        fetch_id: (0, _uniqid.default)(),
        has_cv: response.has_cv,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
    component.setState({});
  };
  fetchUser = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/user/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        users: response.users
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/professional-domain/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCompany = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/company/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        companies: response.companies
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleDepChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const value = event.value;
    const name = event.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchDepartment(event.value);
  };

  /* fetchDepartment = (department) =>
  {
  	const component = this, props = this.props, state = this.state;
  
  	qwest.get(`https://geo.api.gouv.fr/departements?nom=${department}&limit=5`)
  	.then(data =>{
  		component.setState( {autocompleteDep : JSON.parse(data.response)});
  		component.setState( {show_suggestions :true})
  	} )
  	.catch(function (error, xhr, response)
  	{
  		console.error(response?.error || response?.raw || error);
  
  		setState(
  		{
  			...getErrorsFromResponse(
  			{
  				response: response
  			})
  		});
  	});
  } */

  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const candidate = (0, _getFormData.default)({
      state: state,
      pattern: 'candidate['
    });
    const url = props.type === 'update' ? '/candidate/update' : '/candidate/create';
    qwest.post(url, candidate).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchCandidate();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/liste-des-candidats');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleCheckboxChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('candidate[')).reduce(function (update, key) {
      console.log(state[key], _is_js.default.string(state[key]));
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  addMonitoring = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = (0, _uniqid.default)();
    let monitoring = state['candidate[monitoring]'];
    monitoring.unshift({
      date: (0, _moment.default)().format('YYYY-MM-DD'),
      time: (0, _moment.default)().format(),
      title: '',
      jobcoach: [app.state.session?.user?.firstname, app.state.session?.user?.lastname].filter(str => str).join(' ') || '',
      comment: '',
      goals: '',
      file: [],
      id: id,
      v2: true,
      tmp: true
    });
    component.setState({
      'candidate[monitoring]': monitoring
    });
  };
  deleteMonitoring = monitoring_id => {
    const component = this,
      props = this.props,
      state = this.state;
    const monitoring_filtered = state['candidate[monitoring]'].filter(function (monitoring) {
      return monitoring['id'] !== monitoring_id;
    });
    let binary_file = '__files-candidate[monitoring][' + monitoring_id + '][file]';
    component.setState({
      'candidate[monitoring]': monitoring_filtered,
      [binary_file]: undefined
    });
  };
  handleMonitoringChange = ({
    e,
    value,
    name,
    id,
    field_name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let monitoring = (state['candidate[monitoring]'] || []).find(monitoring => monitoring.id === id);
    monitoring[field_name] = value;
    if (field_name === 'title' && value) monitoring.v2 = true;
    component.setState({
      'candidate[monitoring]': state['candidate[monitoring]']
    });
  };
  handleMonitoringDateChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = name.split('candidate[monitoring][')[1];
    id = id.slice(0, id.indexOf(']'));
    let monitoring = (state['candidate[monitoring]'] || []).find(monitoring => monitoring.id === id);
    if (monitoring) {
      monitoring.date = value;
      component.setState({
        'candidate[monitoring]': state['candidate[monitoring]']
      });
    }
  };
  handleActionDateChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = name.split('candidate[action_list][')[1];
    id = id.slice(0, id.indexOf(']'));
    let action = (state['candidate[action_list]'] || []).find(infos => infos.id === id);
    if (action) {
      action.date = value;
      component.setState({
        'candidate[action_list]': state['candidate[action_list]']
      });
    }
  };
  handleMonitoringFileChange = ({
    e,
    previews,
    name,
    id
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const files_descriptor = previews.map(function (preview) {
      let data = {
        status: preview.file instanceof File ? 'new' : 'uploaded'
      };
      if (data.status === 'uploaded') {
        if (preview.url) data.url = preview.url;
        if (preview.pdf) data.pdf = preview.pdf;
      } else {
        data.filename = preview.filename;
      }
      return data;
    });
    delete state.status_messages[name];
    let monitoring = (state['candidate[monitoring]'] || []).find(monitoring => monitoring.id === id);
    monitoring.file = files_descriptor;
    component.setState({
      ['__files-' + name]: previews,
      'candidate[monitoring]': state['candidate[monitoring]'],
      status_messages: state.status_messages,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  addAction = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = (0, _uniqid.default)();
    let action_list = state['candidate[action_list]'];
    action_list.push({
      date: (0, _moment.default)().format('YYYY-MM-DD'),
      comment: '',
      file: [],
      id: id
    });
    component.setState({
      'candidate[action_list]': action_list
    });
  };
  deleteAction = action_list_id => {
    const component = this,
      props = this.props,
      state = this.state;
    const action_list_filtered = state['candidate[action_list]'].filter(function (action_list) {
      return action_list['id'] !== action_list_id;
    });
    let binary_file = '__files-candidate[action_list][' + action_list_id + '][file]';
    component.setState({
      'candidate[action_list]': action_list_filtered,
      [binary_file]: undefined
    });
  };
  handleActionChange = ({
    e,
    value,
    name,
    id,
    field_name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let action_list = (state['candidate[action_list]'] || []).find(action_list => action_list.id === id);
    action_list[field_name] = value;
    component.setState({
      action_list: state.action_list
    });
  };
  handleActionFileChange = ({
    e,
    previews,
    name,
    id
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const files_descriptor = previews.map(function (preview) {
      let data = {
        status: preview.file instanceof File ? 'new' : 'uploaded'
      };
      if (data.status === 'uploaded') {
        if (preview.url) data.url = preview.url;
        if (preview.pdf) data.pdf = preview.pdf;
      } else {
        data.filename = preview.filename;
      }
      return data;
    });
    delete state.status_messages[name];
    let action_list = (state['candidate[action_list]'] || []).find(action_list => action_list.id === id);
    action_list.file = files_descriptor;
    component.setState({
      ['__files-' + name]: previews,
      action_list: state.action_list,
      status_messages: state.status_messages,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleAccountStatusChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      'candidate[monitoring_status]': value,
      error: undefined,
      status_messages: status_messages
    });
  };
  getTutorName = tutor_id => {
    const component = this,
      props = this.props,
      state = this.state;
    let tutor = (state.users || []).find(user => user.id === tutor_id);
    if (tutor) {
      return tutor?.lastname + ' ' + tutor?.firstname;
    } else {
      return 'Tuteur non renseigné';
    }
  };
  getStatusLabel = status => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_label;
    switch (status) {
      case 'En attente dossier':
        status_label = 'En attente dossier';
        break;
      case "En file d'attente":
        status_label = "En file d'attente";
        break;
      case "Réorienté":
        status_label = "Réorienté";
        break;
      case 'refused':
        status_label = 'Non accepté';
        break;
      case 'waiting':
        status_label = 'En attente';
        break;
      case 'accepted':
        status_label = 'Accepté';
        break;
      case 'unsubscribe':
        status_label = 'Désinscrit';
        break;
      default:
        '';
    }
    return status_label;
  };
  openAccountStatusModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openAccountStatusModal: true,
      monitoring_modal_trigger: e.target
    });
  };
  closeAccountStatusModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openAccountStatusModal: false,
      monitoring_modal_trigger: undefined
    });
  };
  toggle = (e, id) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.open === id) {
      component.setState({
        open: undefined
      });
    } else {
      component.setState({
        open: id
      });
    }
  };
  getJobOptions = job => {
    const component = this,
      props = this.props,
      state = this.state;
    const job_option = _options.default[job];
    let job_items = job_option.map(function (job_item, i) {
      let output = /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: job_item.value,
        key: job_item.value
      }, job_item.label);
      return output;
    });
    return job_items;
  };
  handleGroupingSelectChange = (e, name) => {
    const component = this,
      props = this.props;
    let value = e.target.value;
    component.setState({
      [name]: value
    });
  };
  getCompanyData = company_id => {
    const component = this,
      props = this.props,
      state = this.state;
    let company = (state.companies || []).find(company => company.id === company_id);
    return company;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const user_roles = app.state.session?.user?.roles;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const tutor_options = (state.users || []).filter(user => user.roles.includes('super_admin') === false).map(function (user) {
      let option = {
        label: user.lastname + ' ' + user.firstname,
        value: user.id
      };
      return option;
    });
    tutor_options.sort((a, b) => {
      const nameA = a.label;
      const nameB = b.label;
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    let professional_domains_options = (state.professional_domains || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(function (company_activity) {
      let option = {
        label: company_activity.label,
        value: company_activity.id
      };
      return option;
    });
    let account_status_list = (state['candidate[monitoring_status]'] || []).map(function (account_status, i) {
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: i
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _moment.default)(account_status.send_date).format('DD/MM/YYYY')), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, account_status.comment), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getStatusLabel(account_status.status)));
      return output;
    });
    const interested_companies_columns = [{
      id: 'company_name',
      sortable: false,
      numeric: false,
      label: 'Nom de l\'entreprise'
    }, {
      id: 'lastname',
      sortable: false,
      numeric: false,
      label: 'Nom'
    }, {
      id: 'firstname',
      sortable: false,
      numeric: false,
      label: 'Prénom'
    }, {
      id: 'login',
      sortable: false,
      numeric: false,
      label: 'Email'
    }, {
      id: 'phone_number',
      sortable: false,
      numeric: false,
      label: 'Téléphone'
    }];
    let interested_companies_list = (state['candidate[interested_companies]'] || []).map(function (company_id) {
      let company = component.getCompanyData(company_id);
      if (!company) return;
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: company_id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, company.company_name), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, company.lastname), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, company.firstname), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, company.login), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, company.home_phone_number, ' ', company.phone_number));
      return output;
    });
    const columns = [{
      id: 'send_date',
      sortable: false,
      numeric: false,
      label: 'Date',
      center: true
    }, {
      id: 'comment',
      sortable: false,
      numeric: false,
      label: 'Commentaire',
      center: true
    }, {
      id: 'status',
      sortable: false,
      numeric: false,
      label: 'Statut',
      center: true
    }];
    let monitoring_list = (state['candidate[monitoring]'] || []).map(function (monitoring, i) {
      let modifiers = ['monitoring'];
      if (monitoring.id === state.open) modifiers.push('open');
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _bemit.default)('c-collapse', modifiers),
        key: monitoring.id
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: (0, _bemit.default)('c-collapse-toggle', modifiers),
        onClick: e => component.toggle(e, monitoring.id)
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "c-collapse-toggle__txt"
      }, [!monitoring.date ? undefined : (0, _moment.default)(monitoring.date).isValid() ? (0, _moment.default)(monitoring.date).format('DD/MM/YYYY') : 'Date invalide', monitoring.jobcoach, monitoring.title].filter(str => str).join(' - '), !monitoring.jobcoach && !monitoring.title && ![true, 'true'].includes(monitoring.v2) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " Suivi - ", i + 1) : undefined)), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
        in: state.open === monitoring.id,
        timeout: "auto",
        className: "c-collapse__collapsed"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 3,
        classes: props.classes,
        className: "u-padding-10"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        md: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        name: 'candidate[monitoring][' + monitoring.id + '][date]',
        label: "Date du RDV",
        onChange: component.handleMonitoringDateChange,
        value: monitoring.date,
        error: state.status_messages?.['candidate[monitoring][' + monitoring.id + '][date]']?.error,
        key: state.fetch_id
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleMonitoringChange({
          e,
          name,
          value,
          id: monitoring.id,
          field_name: 'jobcoach'
        }),
        value: monitoring.jobcoach || "",
        name: 'candidate[monitoring][' + monitoring.id + '][jobcoach]',
        type: "text",
        label: "Nom du job coach",
        className: "u-padding-top-15",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        md: 3
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleMonitoringChange({
          e,
          name,
          value,
          id: monitoring.id,
          field_name: 'title'
        }),
        value: monitoring.title || "",
        name: 'candidate[monitoring][' + monitoring.id + '][title]',
        type: "text",
        label: "Libell\xE9 du suivi",
        className: "u-padding-top-15",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
        accept: ".pdf",
        onChange: ({
          e,
          previews,
          name
        }) => {
          component.handleFileChange;
          component.handleMonitoringFileChange({
            e,
            previews,
            name,
            id: monitoring.id
          });
        },
        name: 'candidate[monitoring][' + monitoring.id + '][file]',
        data: state,
        multiple: true,
        status: state.status_messages,
        label: "Fichier"
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleMonitoringChange({
          e,
          name,
          value,
          id: monitoring.id,
          field_name: 'comment'
        }),
        value: monitoring.comment || '',
        name: 'candidate[monitoring][' + monitoring.id + '][comment]',
        label: "Notes",
        multiline: true,
        rows: "5",
        "without-headings": true,
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleMonitoringChange({
          e,
          name,
          value,
          id: monitoring.id,
          field_name: 'goals'
        }),
        value: monitoring.goals || '',
        name: 'candidate[monitoring][' + monitoring.id + '][goals]',
        label: "Objectifs pour le prochain RDV",
        multiline: true,
        rows: "5",
        "without-headings": true,
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-flex u-flex-gap-25 u-content-center u-items-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteMonitoring(monitoring.id)
      }, "Quitter sans sauvegarder"), /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: component.validate
      }, props.type === 'update' ? 'Enregistrer' : 'Créer')))));
      return output;
    });
    let actions_list = (state['candidate[action_list]'] || []).sort((a, b) => (0, _moment.default)(b.date).diff((0, _moment.default)(a.date))).map(function (action_list, i) {
      let modifiers = ['action_list'];
      if (action_list.id === state.open) modifiers.push('open');
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _bemit.default)('c-collapse', modifiers),
        key: action_list.id
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: (0, _bemit.default)('c-collapse-toggle', modifiers),
        onClick: e => component.toggle(e, action_list.id)
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "c-collapse-toggle__txt"
      }, "Action - ", i + 1)), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
        in: state.open === action_list.id,
        timeout: "auto",
        className: "c-collapse__collapsed"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 3,
        classes: props.classes,
        className: "u-padding-10"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        name: 'candidate[action_list][' + action_list.id + '][date]',
        label: "Date du RDV",
        onChange: component.handleActionDateChange,
        value: action_list.date,
        error: state.status_messages?.['candidate[action_list][' + action_list.id + '][date]']?.error,
        key: state.fetch_id
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
        accept: ".pdf",
        onChange: ({
          e,
          previews,
          name
        }) => {
          component.handleFileChange;
          component.handleActionFileChange({
            e,
            previews,
            name,
            id: action_list.id
          });
        },
        name: 'candidate[action_list][' + action_list.id + '][file]',
        data: state,
        multiple: true,
        status: state.status_messages,
        label: "Fichier"
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleActionChange({
          e,
          name,
          value,
          id: action_list.id,
          field_name: 'comment'
        }),
        value: action_list.comment || '',
        name: 'candidate[action_list][' + action_list.id + '][comment]',
        label: "Notes",
        multiline: true,
        rows: "5",
        "without-headings": true,
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteAction(action_list.id)
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))))));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "candidate-title-back"
    }, state['candidate[lastname]'], ' ', state['candidate[firstname]'], ' ', "(", component.getTutorName(state['candidate[tutor]']), ")"), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "tabs-paper",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      value: state.current_tab,
      onChange: component.handleTabChange,
      name: "current_tab",
      variant: "scrollable",
      scrollButtons: "auto",
      indicatorColor: "primary",
      textColor: "primary"
    }, /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Coordonn\xE9es",
      value: 0
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Situation",
      value: 1
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "TSA",
      value: 2
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Particularit\xE9(s)",
      value: 3
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "RQTH",
      value: 4
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Suivi externe",
      value: 5
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Ressources",
      value: 6
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "CV",
      value: 7
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Suivi",
      value: 8
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Actions \xE0 mener",
      value: 9
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Statut",
      value: 10
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Entreprise int\xE9r\xE9ss\xE9e",
      value: 11
    }))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 0,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[lastname]'],
      name: "candidate[lastname]",
      type: "text",
      label: "Nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[firstname]'],
      name: "candidate[firstname]",
      type: "text",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[home_phone_number]'],
      name: "candidate[home_phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone fixe",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[phone_number]'],
      name: "candidate[phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone portable",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      name: "candidate[birthdate]",
      label: "Date de naissance",
      onChange: component.handleV2Change,
      value: state['candidate[birthdate]'],
      error: state.status_messages?.['candidate[birthdate]']?.error,
      key: state.fetch_id
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      name: "candidate[last_membership]",
      label: "Date de derni\xE8re adh\xE9sion",
      onChange: component.handleV2Change,
      value: state['candidate[last_membership]'],
      error: state.status_messages?.['candidate[last_membership]']?.error,
      key: state.fetch_id
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid-item-radios u-margin-top-10"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "grid-radio"
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[membership]'] === 'yes',
      onChange: component.handleRadioChange,
      value: "yes",
      color: "primary",
      name: "candidate[membership]"
    }), "Adh\xE9rent"), /*#__PURE__*/_react.default.createElement("span", {
      className: "grid-radio"
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[membership]'] === 'no',
      onChange: component.handleRadioChange,
      value: "no",
      color: "primary",
      name: "candidate[membership]"
    }), "Non adh\xE9rent")), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "J\u2019accepte que l\u2019association Aspiejob m\u2019envoie des informations sur les actions de l\u2019association li\xE9es \xE0 l\u2019accompagnement professionnel des personnes diagnostiqu\xE9es avec un trouble du spectre autistique",
      name: "candidate[infos_news]",
      value: (0, _utilities.isTrue)(state['candidate[infos_news]']),
      status: state.status_messages,
      disabled: true
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Adresse",
      onChange: component.handleChange,
      value: state['candidate[address][line_1]'],
      name: "candidate[address][line_1]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Compl\xE9ment d'adresse",
      onChange: component.handleChange,
      value: state['candidate[address][line_2]'],
      name: "candidate[address][line_2]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Code postal",
      onChange: component.handleChange,
      value: state['candidate[address][postal_code]'],
      name: "candidate[address][postal_code]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Ville",
      onChange: component.handleChange,
      value: state['candidate[address][city]'],
      name: "candidate[address][city]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[login]'],
      name: "candidate[login]",
      type: "text",
      label: "E-mail du candidat",
      autocomplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[password]'],
      name: "candidate[password]",
      type: "password",
      label: "Mot de passe du candidat (minimum 12 caract\xE8res)",
      autocomplete: "new-password",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "D\xE9partement",
      onChange: component.handleChange,
      value: state['candidate[department]'],
      name: "candidate[department]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En cochant cette case, vous (le candidat majeur ou le repr\xE9sentant l\xE9gal du candidat faisant l\u2019objet d\u2019une mesure de tutelle ou de curatelle) consentez \xE0 la collecte et au traitement par l\u2019association Aspiejob de la donn\xE9e relative au diagnostic du candidat afin d\u2019adapter les services rendus par Aspiejob. Vous pourrez retirer votre consentement \xE0 tout moment, sans avoir \xE0 en justifier.",
      value: (0, _utilities.isTrue)(state['candidate[data_agreement]']),
      status: state.status_messages,
      disabled: true
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 1,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, !user_roles.includes('accompanist') ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form u-padding-left-0"
    }, "Job Coach"), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['candidate[tutor]'],
      name: "candidate[tutor]",
      label: "",
      status: state.status_messages,
      options: tutor_options,
      "default-value": tutor_options[0]?.value
    })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form u-padding-left-0"
    }, "Objectif de l'accompagnement"), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['candidate[monitoring_type]'],
      name: "candidate[monitoring_type]",
      label: "",
      status: state.status_messages,
      options: monitoring_type_options,
      "default-value": monitoring_type_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form u-padding-left-0"
    }, "Statut de l'accompagnement"), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['candidate[support]'],
      name: "candidate[support]",
      label: "",
      status: state.status_messages,
      options: _options.default.support_options,
      "default-value": _options.default.support_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form u-padding-left-0"
    }, "Dispositif"), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['candidate[dispositif]'],
      name: "candidate[dispositif]",
      label: "",
      status: state.status_messages,
      options: _options.default.options_dispositif,
      "default-value": _options.default.options_dispositif[0]?.value
    })), state['candidate[support]'] === "Recherche de stage" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Stage souhait\xE9e",
      onChange: component.handleChange,
      value: state['candidate[stage]'],
      name: "candidate[stage]",
      status: state.status_messages
    })) : undefined, state['candidate[support]'] === "Recherche de formation" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Formation envisag\xE9e",
      onChange: component.handleChange,
      value: state['candidate[formation]'],
      name: "candidate[formation]",
      status: state.status_messages
    })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[support_comment]"] || '',
      name: "candidate[support_comment]",
      label: "Commentaire",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Situation actuelle"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[current_situation]"] || '',
      name: "candidate[current_situation]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En poste CDI/CDD/Fonctionnaire",
      name: "candidate[now_situation][employed]",
      value: state['candidate[now_situation][employed]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En formation",
      name: "candidate[now_situation][training]",
      value: state['candidate[now_situation][training]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En arr\xEAt maladie",
      name: "candidate[now_situation][sick_leave]",
      value: state['candidate[now_situation][sick_leave]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Sans emploi - indemnis\xE9",
      name: "candidate[now_situation][jobless_paid]",
      value: state['candidate[now_situation][jobless_paid]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Sans emploi - non indemnis\xE9",
      name: "candidate[now_situation][jobless_not_paid]",
      value: state['candidate[now_situation][jobless_not_paid]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[situation_info]"] || '',
      name: "candidate[situation_info]",
      label: "Pour quel besoin contactez-vous aujourd'hui Aspiejob ? (Recherche emploi, prise de poste, maintien en emploi) et quelles sont vos attentes vis \xE0 vis d'Aspiejob ?",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[job_support]"] || '',
      name: "candidate[job_support]",
      label: "Si vous b\xE9n\xE9ficiez d'un accompagnement vers l'emploi pr\xE9cisez : (SPE, PEA, association, etc...)",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[other_support]"] || '',
      name: "candidate[other_support]",
      label: "Si vous b\xE9n\xE9ficiez d'un autre accompagnement autre, pr\xE9cisez : (Assistante sociale, Educateur, Association, Th\xE9rapeute, etc...)",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[pro_project]"] || '',
      name: "candidate[pro_project]",
      label: "Avez-vous un projet professionnel ? Si oui lequel ?",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    }))), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Contact\xE9 par"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[contact_by]'] === "Professionnel",
      onChange: component.handleRadioChange,
      value: "Professionnel",
      color: "primary",
      name: "candidate[contact_by]",
      inputProps: {
        'aria-label': 'Professionnel'
      }
    }), "Professionnel"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[contact_by]'] === "Le candidat",
      onChange: component.handleRadioChange,
      value: "Le candidat",
      color: "primary",
      name: "candidate[contact_by]",
      inputProps: {
        'aria-label': 'Le candidat'
      }
    }), "Le candidat"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[contact_by]'] === "Famille",
      onChange: component.handleRadioChange,
      value: "Famille",
      color: "primary",
      name: "candidate[contact_by]",
      inputProps: {
        'aria-label': 'Famille'
      }
    }), "Famille"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[contact_by]'] === "Autre",
      onChange: component.handleRadioChange,
      value: "Autre",
      color: "primary",
      name: "candidate[contact_by]",
      inputProps: {
        'aria-label': 'Autre'
      }
    }), "Autre"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Nom et coordonn\xE9es du contact"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[other_contact]"] || '',
      name: "candidate[other_contact]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Situation personnelle/autonomie"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[personal_situation]"] || '',
      name: "candidate[personal_situation]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Amis, famille, soutien"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[friends_and_family]"] || '',
      name: "candidate[friends_and_family]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Interactions sociales"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[social_interactions]"] || '',
      name: "candidate[social_interactions]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 2,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Diagnostic TSA"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_current_status]'] === 'Diagnostiqué',
      onChange: component.handleRadioChange,
      value: 'Diagnostiqué',
      color: "primary",
      name: "candidate[tsa_current_status]",
      inputProps: {
        'aria-label': 'Diagnostiqué'
      }
    }), "Diagnostiqu\xE9"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_current_status]'] === "Non diagnostiqué",
      onChange: component.handleRadioChange,
      value: "Non diagnostiqué",
      color: "primary",
      name: "candidate[tsa_current_status]",
      inputProps: {
        'aria-label': 'Non diagnostiqué'
      }
    }), "Non diagnostiqu\xE9"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      name: "candidate[tsa_diagnostic][date]",
      label: "Date",
      onChange: component.handleChange,
      value: state['candidate[tsa_diagnostic][date]'],
      error: state.status_messages?.['candidate[tsa_diagnostic][date']?.error,
      key: state.fetch_id
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".pdf",
      onChange: component.handleFileChange,
      name: "candidate[tsa_diagnostic][file]",
      data: state,
      status: state.status_messages,
      label: "Fichier"
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Praticien ayant confirm\xE9 le diagnostic"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "",
      onChange: component.handleChange,
      value: state['candidate[tsa_diagnostic][doctor]'],
      name: "candidate[tsa_diagnostic][doctor]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Type de tests effectu\xE9s et observations principales"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[tsa_diagnostic][test_type]"] || '',
      name: "candidate[tsa_diagnostic][test_type]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Suivi"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Ergoth\xE9rapeute",
      name: "candidate[tsa_diagnostic][accompany][ergotherapeute]",
      value: state['candidate[tsa_diagnostic][accompany][ergotherapeute]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Psychologue",
      name: "candidate[tsa_diagnostic][accompany][psychologue]",
      value: state['candidate[tsa_diagnostic][accompany][psychologue]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Pair aidant",
      name: "candidate[tsa_diagnostic][accompany][pair_aidant]",
      value: state['candidate[tsa_diagnostic][accompany][pair_aidant]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Pas de suivi",
      name: "candidate[tsa_diagnostic][accompany][non_suivi]",
      value: state['candidate[tsa_diagnostic][accompany][non_suivi]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Psychiatre",
      name: "candidate[tsa_diagnostic][accompany][psychiatre]",
      value: state['candidate[tsa_diagnostic][accompany][psychiatre]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Autre(s)",
      name: "candidate[tsa_diagnostic][accompany][autres]",
      value: state['candidate[tsa_diagnostic][accompany][autres]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Type"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_diagnostic][type]'] === "Comportementale",
      onChange: component.handleRadioChange,
      value: "Comportementale",
      color: "primary",
      name: "candidate[tsa_diagnostic][type]",
      inputProps: {
        'aria-label': 'Comportementale'
      }
    }), "Comportementale"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_diagnostic][type]'] === "Non comportementale",
      onChange: component.handleRadioChange,
      value: "Non comportementale",
      color: "primary",
      name: "candidate[tsa_diagnostic][type]",
      inputProps: {
        'aria-label': 'Non comportementale'
      }
    }), "Non comportementale"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Nom et/ou contact"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[tsa_diagnostic][contact]"] || '',
      name: "candidate[tsa_diagnostic][contact]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Commentaire"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[tsa_diagnostic][comment]"] || '',
      name: "candidate[tsa_diagnostic][comment]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Comorbidit\xE9s"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[tsa_diagnostic][associated_disorders]"] || '',
      name: "candidate[tsa_diagnostic][associated_disorders]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 3,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Particularit\xE9(s) sensorielle(s)"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Auditive",
      name: "candidate[special_feature][sensory][audititive]",
      value: state['candidate[special_feature][sensory][audititive]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Gustative",
      name: "candidate[special_feature][sensory][gustative]",
      value: state['candidate[special_feature][sensory][gustative]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Olfactive",
      name: "candidate[special_feature][sensory][olfactive]",
      value: state['candidate[special_feature][sensory][olfactive]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Proprioceptive et vestibulaire",
      name: "candidate[special_feature][sensory][proprioceptive]",
      value: state['candidate[special_feature][sensory][proprioceptive]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Tactile",
      name: "candidate[special_feature][sensory][tactile]",
      value: state['candidate[special_feature][sensory][tactile]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Visuelle",
      name: "candidate[special_feature][sensory][visuelle]",
      value: state['candidate[special_feature][sensory][visuelle]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][sensory_comment]"] || '',
      name: "candidate[special_feature][sensory_comment]",
      label: "Commentaire",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Particularit\xE9s cognitive"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][verbal_comprehension]"] || '',
      name: "candidate[special_feature][verbal_comprehension]",
      label: "Compr\xE9hension verbale",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][information_processing_speed]"] || '',
      name: "candidate[special_feature][information_processing_speed]",
      label: "Vitesse de traitement de l\u2019information",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][perceptual_reasoning]"] || '',
      name: "candidate[special_feature][perceptual_reasoning]",
      label: "Raisonnement perceptif",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][working_memory]"] || '',
      name: "candidate[special_feature][working_memory]",
      label: "M\xE9moire de travail",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "S'organiser"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][organization]'] === "Facile",
      onChange: component.handleRadioChange,
      value: "Facile",
      color: "primary",
      name: "candidate[special_feature][organization]",
      inputProps: {
        'aria-label': 'Facile'
      }
    }), "Facile"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][organization]'] === "Moyen",
      onChange: component.handleRadioChange,
      value: "Moyen",
      color: "primary",
      name: "candidate[special_feature][organization]",
      inputProps: {
        'aria-label': 'Moyen'
      }
    }), "Moyen"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][organization]'] === "Difficile",
      onChange: component.handleRadioChange,
      value: "Difficile",
      color: "primary",
      name: "candidate[special_feature][organization]",
      inputProps: {
        'aria-label': 'Difficile'
      }
    }), "Difficile"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Pr\xE9f\xE8re les instructions \xE9crite"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][written_instructions]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[special_feature][written_instructions]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][written_instructions]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[special_feature][written_instructions]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, " Difficult\xE9s de motricit\xE9 fine"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][motor_difficulties]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[special_feature][motor_difficulties]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][motor_difficulties]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[special_feature][motor_difficulties]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, " Se d\xE9placer"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Prend les transports en commun mais difficult\xE9es d\u2019ordre sensoriel (bruit notamment) qui peuvent amener \xE0 \xE9viter ce type de transport",
      name: "candidate[displacement_difficulties][difficulte]",
      value: state['candidate[displacement_difficulties][difficulte]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Prend les transports en commun",
      name: "candidate[displacement_difficulties][transport_commun]",
      value: state['candidate[displacement_difficulties][transport_commun]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Conduis",
      name: "candidate[displacement_difficulties][conduit]",
      value: state['candidate[displacement_difficulties][conduit]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Se d\xE9place \xE0 v\xE9lo",
      name: "candidate[displacement_difficulties][velo]",
      value: state['candidate[displacement_difficulties][velo]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Se d\xE9place \xE0 pied",
      name: "candidate[displacement_difficulties][a_pied]",
      value: state['candidate[displacement_difficulties][a_pied]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Ne peut pas sortir de chez lui/elle",
      name: "candidate[displacement_difficulties][pas_sortie]",
      value: state['candidate[displacement_difficulties][pas_sortie]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "T\xE9l\xE9phoner"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][call]'] === "Facile",
      onChange: component.handleRadioChange,
      value: "Facile",
      color: "primary",
      name: "candidate[special_feature][call]",
      inputProps: {
        'aria-label': 'Facile'
      }
    }), "Facile"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][call]'] === "Moyen",
      onChange: component.handleRadioChange,
      value: "Moyen",
      color: "primary",
      name: "candidate[special_feature][call]",
      inputProps: {
        'aria-label': 'Moyen'
      }
    }), "Moyen"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[special_feature][call]'] === "Difficile",
      onChange: component.handleRadioChange,
      value: "Difficile",
      color: "primary",
      name: "candidate[special_feature][call]",
      inputProps: {
        'aria-label': 'Difficile'
      }
    }), "Difficile"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Rapport au num\xE9rique"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Besoin d'aide/explications",
      name: "candidate[special_feature][digital_relationship][need_help]",
      value: state['candidate[special_feature][digital_relationship][need_help]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Ma\xEEtrise",
      name: "candidate[special_feature][digital_relationship][control]",
      value: state['candidate[special_feature][digital_relationship][control]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Privil\xE9gier le format papier",
      name: "candidate[special_feature][digital_relationship][on_paper]",
      value: state['candidate[special_feature][digital_relationship][on_paper]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Face \xE0 son interlocuteur"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Difficult\xE9 pour regarder dans les yeux",
      name: "candidate[special_feature][reaction_with_interlocutor][difficulty_looking]",
      value: state['candidate[special_feature][reaction_with_interlocutor][difficulty_looking]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Difficult\xE9 pour rester assis",
      name: "candidate[special_feature][reaction_with_interlocutor][difficulty_sitting]",
      value: state['candidate[special_feature][reaction_with_interlocutor][difficulty_sitting]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Difficult\xE9 pour serrer la main",
      name: "candidate[special_feature][reaction_with_interlocutor][shaking_hands]",
      value: state['candidate[special_feature][reaction_with_interlocutor][shaking_hands]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Pas de particularit\xE9 visible",
      name: "candidate[special_feature][reaction_with_interlocutor][no_visible_difficulty]",
      value: state['candidate[special_feature][reaction_with_interlocutor][no_visible_difficulty]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Se tient trop pr\xE8s/trop loin",
      name: "candidate[special_feature][reaction_with_interlocutor][stand_too_far_too_close]",
      value: state['candidate[special_feature][reaction_with_interlocutor][stand_too_far_too_close]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Capacit\xE9 \xE0 manger et \xE0 faire des pauses en groupe"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][ability_to_eat_with_others]"] || '',
      name: "candidate[special_feature][ability_to_eat_with_others]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Gestion des \xE9motions"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][emotions_managing]"] || '',
      name: "candidate[special_feature][emotions_managing]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Accompagnement m\xE9dicamenteux"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[special_feature][medication_support]"] || '',
      name: "candidate[special_feature][medication_support]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 4,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Statut"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][status]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[rqth][status]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][status]'] === "Demande en cours",
      onChange: component.handleRadioChange,
      value: "Demande en cours",
      color: "primary",
      name: "candidate[rqth][status]",
      inputProps: {
        'aria-label': 'Demande en cours'
      }
    }), "Demande en cours"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][status]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[rqth][status]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Type"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][type]'] === "Milieu ordinaire",
      onChange: component.handleRadioChange,
      value: "Milieu ordinaire",
      color: "primary",
      name: "candidate[rqth][type]",
      inputProps: {
        'aria-label': 'Milieu ordinaire'
      }
    }), "Milieu ordinaire"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][type]'] === "Milieu protégé",
      onChange: component.handleRadioChange,
      value: "Milieu protégé",
      color: "primary",
      name: "candidate[rqth][type]",
      inputProps: {
        'aria-label': 'Milieu protégé'
      }
    }), "Milieu prot\xE9g\xE9"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Commentaire"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[rqth][comment]"] || '',
      name: "candidate[rqth][comment]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      name: "candidate[rqth][date]",
      label: "Date expiration",
      onChange: component.handleChange,
      value: state['candidate[rqth][date]'],
      error: state.status_messages?.['candidate[rqth][date]']?.error,
      key: state.fetch_id
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".pdf",
      onChange: component.handleFileChange,
      name: "candidate[rqth][file]",
      data: state,
      status: state.status_messages,
      label: "Fichier"
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 5,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Organisme"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "P\xF4le Emploi",
      name: "candidate[external_accompany][external_accompany][pole_emploi]",
      value: state['candidate[external_accompany][external_accompany][pole_emploi]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Cap Emploi",
      name: "candidate[external_accompany][external_accompany][cap_emploi]",
      value: state['candidate[external_accompany][external_accompany][cap_emploi]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Mission locale",
      name: "candidate[external_accompany][external_accompany][mission_locale]",
      value: state['candidate[external_accompany][external_accompany][mission_locale]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Autre association",
      name: "candidate[external_accompany][external_accompany][autre_association]",
      value: state['candidate[external_accompany][external_accompany][autre_association]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Pas de suivi",
      name: "candidate[external_accompany][external_accompany][pas_suivi]",
      value: state['candidate[external_accompany][external_accompany][pas_suivi]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Autre",
      name: "candidate[external_accompany][external_accompany][autre]",
      value: state['candidate[external_accompany][external_accompany][autre]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[external_accompany][contact_and_comment]"] || '',
      name: "candidate[external_accompany][contact_and_comment]",
      label: "Nom et coordonn\xE9es / commentaires",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Suivi social"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Assistante sociale",
      name: "candidate[external_accompany][social_company][assistante_sociale]",
      value: state['candidate[external_accompany][social_company][assistante_sociale]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Association",
      name: "candidate[external_accompany][social_company][association]",
      value: state['candidate[external_accompany][social_company][association]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Autre",
      name: "candidate[external_accompany][social_company][autre]",
      value: state['candidate[external_accompany][social_company][autre]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[external_accompany][social_comment]"] || '',
      name: "candidate[external_accompany][social_comment]",
      label: "Commentaires",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 6,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "AAH"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][aah]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[resources][aah]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][aah]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[resources][aah]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][aah]'] === "En cours de demande",
      onChange: component.handleRadioChange,
      value: "En cours de demande",
      color: "primary",
      name: "candidate[resources][aah]",
      inputProps: {
        'aria-label': 'En cours de demande'
      }
    }), "En cours de demande"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "RSA"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][rsa]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[resources][rsa]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][rsa]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[resources][rsa]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Ch\xF4mage"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][chomage]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[resources][chomage]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][chomage]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[resources][chomage]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Salaires ou autres ressources de travail"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][revenue]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[resources][revenue]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][revenue]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[resources][revenue]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Aide de la famille"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][family_help]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[resources][family_help]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[resources][family_help]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[resources][family_help]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Commentaire"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[resources][comment]"] || '',
      name: "candidate[resources][comment]",
      label: "",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 7,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['candidate[professional_domain]'],
      name: "candidate[professional_domain]",
      label: "Domaine professionnel",
      status: state.status_messages,
      options: professional_domains_options,
      defaultValue: professional_domains_options[0]?.value
    })), state['candidate[id]'] ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      href: "/candidats/" + state['candidate[id]'],
      color: "primary",
      variant: "contained",
      target: "_blank",
      className: "u-padding-10 u-margin-right-10 u-text-center",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
    }, /*#__PURE__*/_react.default.createElement(_Visibility.default, null))) : undefined, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Secteur g\xE9ographique"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[geographic_sector]'],
      name: "candidate[geographic_sector]",
      type: "text",
      label: "",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Rythme de travail"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Temps partiel",
      name: "candidate[working_rythm][part_time]",
      value: state['candidate[working_rythm][part_time]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Temps plein",
      name: "candidate[working_rythm][full_time]",
      value: state['candidate[working_rythm][full_time]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Travail de jour",
      name: "candidate[working_rythm][working_day]",
      value: state['candidate[working_rythm][working_day]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Travail de nuit",
      name: "candidate[working_rythm][working_night]",
      value: state['candidate[working_rythm][working_night]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[working_rythm_desired_hours]'],
      name: "candidate[working_rythm_desired_hours]",
      type: "text",
      label: "Horaires souhait\xE9s",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "T\xE9l\xE9travail"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[telecommuting]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[telecommuting]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[telecommuting]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[telecommuting]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "CV"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[cv_status]'] === "J'ai fait mon CV",
      onChange: component.handleRadioChange,
      value: "J'ai fait mon CV",
      color: "primary",
      name: "candidate[cv_status]",
      inputProps: {
        'aria-label': 'J\'ai fait mon CV'
      }
    }), "J'ai fait mon CV"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[cv_status]'] === "Je n’ai pas fait mon CV et je souhaite de l’aide pour le rédiger",
      onChange: component.handleRadioChange,
      value: "Je n’ai pas fait mon CV et je souhaite de l’aide pour le rédiger",
      color: "primary",
      name: "candidate[cv_status]",
      inputProps: {
        'aria-label': 'Je n\'ai pas fait mon CV et je souhaite de l’aide pour le rédiger'
      }
    }), "Je n\u2019ai pas fait mon CV et je souhaite de l\u2019aide pour le r\xE9diger"), state.has_cv ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'c-message c-message--green'
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-message__content"
    }, "Ce candidat a un CV en ligne sur la plateforme.", /*#__PURE__*/_react.default.createElement("a", {
      href: '/liste-des-cvs/' + state['candidate[id]'],
      target: "_blank",
      rel: "noreferrer"
    }, "Ouvrir (nouvel onglet)")))) : undefined, state['candidate[cv_status]'] === "J'ai fait mon CV" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      accept: ".pdf,.jpg,.png,.odt,.gif,.docx,.jpeg",
      onChange: component.handleFileChange,
      name: "candidate[cv_download]",
      data: state,
      status: state.status_messages,
      label: "T\xE9l\xE9chargez votre CV"
    })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[competences_interets]"] || '',
      name: "candidate[competences_interets]",
      label: "Mes comp\xE9tences et int\xE9r\xEAts",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 8,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addMonitoring
    }, "Ajouter un suivi")), monitoring_list)), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 9,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addAction
    }, "Ajouter une action \xE0 mener")), actions_list)), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 10,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center u-full-width u-margin-bottom-10"
    }, "Statut en cours : " + component.getStatusLabel(state['candidate[account_status]'])), /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Suivi de statut",
      className: "u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      columns: columns,
      order: "undefined",
      order_by: "undefined",
      row_count: account_status_list.length
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, account_status_list)), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "button",
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: e => component.openAccountStatusModal(e)
    }, "Changer de statut", loader))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 11,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Suivi de statut",
      className: "u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      columns: interested_companies_columns,
      order: "undefined",
      order_by: "undefined",
      row_count: interested_companies_list.length
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, interested_companies_list)), /*#__PURE__*/_react.default.createElement(_LeaveWithoutSavingModal.default, {
      open: state.openLeaveWhithoutSavingModal,
      onClose: component.closeLeaveWhithoutSavingModal
    })), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Enregistrer' : 'Créer ce candidat')), /*#__PURE__*/_react.default.createElement(_AccountStatusModal.default, {
      candidate_id: state['candidate[id]'],
      onAccountChange: component.handleAccountStatusChange,
      onChange: component.handleChange,
      current_status: state['candidate[account_status]'],
      monitoring_account_status: state['candidate[monitoring_status]'],
      open: state.openAccountStatusModal,
      onClose: component.closeAccountStatusModal,
      add_modal_trigger: state.monitoring_modal_trigger
    }), loader);
    return output;
  }
}
exports.default = CandidateForm;
